/* Dark by default; light, or whatever the device says, if a member prefers.
   The choice is kept in this browser and applied before first paint by
   public/theme-init.js, so it survives reloads and never flashes the wrong theme. */

const KEY = 'bn.theme';
export const MODES = ['dark', 'light', 'system'];

export function getTheme() {
  try {
    const t = window.localStorage.getItem(KEY);
    return t === 'light' || t === 'system' ? t : 'dark';
  } catch {
    return 'dark';
  }
}

export function setTheme(mode) {
  const root = document.documentElement;
  if (mode === 'light' || mode === 'dark') root.setAttribute('data-theme', mode);
  else root.removeAttribute('data-theme');
  try {
    window.localStorage.setItem(KEY, mode);
  } catch {
    /* private mode: applies for this visit only */
  }
}

export function nextTheme(mode) {
  return MODES[(MODES.indexOf(mode) + 1) % MODES.length];
}
